module.exports = __webpack_public_path__ + "static/img/25-1.0860c93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/25-1.jpg
// module id = cAAQ
// module chunks = 0